(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["booking-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.querySelector('[data-booking-modal]');
    if (!modal) return;
    var select = modal.querySelector('[data-booking-service]');
    var dateInput = modal.querySelector('[data-booking-date]');

    function openModal(service) {
      if (service && select) {
        var found = false;
        Array.prototype.forEach.call(select.options, function (o) {
          if (o.value === service) found = true;
        });
        if (!found) {
          var o = document.createElement('option');
          o.value = service;
          o.textContent = service;
          select.appendChild(o);
        }
        select.value = service;
      }
      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.body.classList.add('booking-modal-open');
    }
    function closeModal() {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-booking-open]');
      if (opener) {
        e.preventDefault();
        openModal(opener.getAttribute('data-service'));
        return;
      }
      if (e.target.closest('[data-booking-close]')) {
        closeModal();
        return;
      }
      if (e.target === modal) closeModal();
    });

    modal.addEventListener('close', function () {
      document.body.classList.remove('booking-modal-open');
    });

    if (dateInput) {
      dateInput.min = new Date().toISOString().split('T')[0];
    }

    /* Store the reservation in Shopify as a tagged customer (visible in
       Admin → Customers) with the details in the customer note. Runs as a
       background request while the normal contact-form submit proceeds, so
       the notification email is untouched. Plain text only — URLs in form
       fields trip Shopify's spam filter and kill email delivery. */
    var form = modal.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        function val(id) {
          var el = modal.querySelector(id);
          return el && el.value ? el.value : '';
        }
        var note = [];
        if (select && select.value) note.push('Soin : ' + select.value);
        if (val('#BookingModalDate')) note.push('Date souhaitée : ' + val('#BookingModalDate'));
        if (val('#BookingModalTime')) note.push('Heure souhaitée : ' + val('#BookingModalTime'));
        if (val('#BookingModalPhone')) note.push('Téléphone : ' + val('#BookingModalPhone'));
        if (val('#BookingModalMessage')) note.push('Message : ' + val('#BookingModalMessage'));

        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', val('#BookingModalEmail'));
        fd.append('contact[first_name]', val('#BookingModalName'));
        fd.append('contact[tags]', 'Réservation');
        fd.append('contact[note]', note.join('\n'));

        var root = modal.getAttribute('data-routes-root') || '/';
        try {
          fetch(root + 'contact', { method: 'POST', body: fd, keepalive: true });
        } catch (e) { /* storage is best-effort; the email still goes out */ }

        /* Full history: also send the reservation to the reservations app
           (Theme settings → Online booking → Reservation storage endpoint).
           Sent without headers (text/plain) so no CORS preflight can be
           lost while the page navigates away. */
        var endpoint = modal.getAttribute('data-reservation-endpoint');
        if (endpoint) {
          try {
            fetch(endpoint, {
              method: 'POST',
              body: JSON.stringify({
                soin: select && select.value ? select.value : '',
                nom: val('#BookingModalName'),
                email: val('#BookingModalEmail'),
                tel: val('#BookingModalPhone'),
                date: val('#BookingModalDate'),
                heure: val('#BookingModalTime'),
                message: val('#BookingModalMessage')
              }),
              keepalive: true
            });
          } catch (e) { /* best-effort */ }
        }
      });
    }

    /* Reopen after a form submit so the success/error state is visible */
    var autopen = modal.querySelector('[data-booking-autopen]');
    if (autopen) {
      openModal();
      if (autopen.tabIndex === -1) autopen.focus();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    function closeAll(except) {
      document.querySelectorAll('[data-lang-select].is-open').forEach(function (el) {
        if (el === except) return;
        el.classList.remove('is-open');
        var t = el.querySelector('[data-lang-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-lang-toggle]');
      if (toggle) {
        var root = toggle.closest('[data-lang-select]');
        var open = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        closeAll(root);
        return;
      }
      if (!e.target.closest('[data-lang-select]')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
